import { Media } from 'react-bootstrap'
import Link from 'next/link'



function Joining() {
    return (
        <Media className="flex-md-row flex-column">
            <img width={300} src="../../images/test/Picture24.png" alt="Generic placeholder" className="img-fluid mr-3"/>
            <Media.Body>
                <h5 className=" mt-3">Thanks for joining our wellness community!</h5>
                <p className="h7">
                    You now have access to trusted wellness resources, expert interviews and more. Our content is written and
                    curated by <Link href="/nutritional-advisors"><a>nutritional scientists</a></Link> and experts in various fields of health and wellness. Watch the videos below
                    to learn how to get
                    the most out of your membership.
                </p>
            </Media.Body>
        </Media>
    )
}

export default Joining
